<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Controle Cobranças Garantidoras X Imobiliárias</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item">Controle Cobranças</li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">Filtros</v-tab>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <div class="row gp-query-filters">
                                                    <div class="col-md-4 col-lg-4" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <v-autocomplete v-model="GarantidoraSelected" :items="ListGarantidorasGeral" item-title="garNomeEmpresa" item-value="garId"
                                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhum registro encontrado" @update:model-value="BuscaImobiliarias()" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4"
                                                        v-if="User.tpeid == 1 || User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Imobiliaria</label>
                                                            <v-autocomplete v-model="ImobiliariaSelected" :items="ListImobiliarias" item-title="imoNomeEmpresa" item-value="imoId"
                                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhum registro encontrado" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Forma Pagamento</label>
                                                            <select v-model="PagamentoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListPagamentosGeral"
                                                                    :key="optionTipo.cfpId" :value="optionTipo.cfpId">{{
                                                                        optionTipo.cfpNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Ano Cobrança</label>
                                                            <select v-model="AnoSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListAnoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Mês Cobrança</label>
                                                            <select v-model="MesSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListMesGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Situação</label>
                                                            <select v-model="SituacaSelected"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListSituacaoGeral"
                                                                    :key="optionTipo.Id" :value="optionTipo.Id">{{
                                                                        optionTipo.Nome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12 gp-query-actions">
                                                        <div class="form-group">
                                                            <button type="button" class="btn btn-info"
                                                                style="color:#ffffff;" @click="Filtar()">
                                                                <i class="fas fa-search"></i> Pesquisar
                                                            </button>
                                                            <a href="#" @click="Cancel()"
                                                                class="btn btn-outline-secondary"><i class="fas fa-eraser"></i> Limpar</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Resultado</h4>
                                </div>
                            </div>
                            <div class="card-body"
                                v-if="ListCobrancas != '' && ListGarantidorasGeral != null && ListImobiliariasGeral != ''">
                                <v-row>
                                    <v-col cols="12" md="3"
                                        style="text-align: right;padding-right: 15px;padding-top: 20px;">
                                        <button @click="exportCSV" class="btn-sm btn-warning">Exportar CSV</button>
                                    </v-col>
                                    <v-col cols="12" md="3" style="text-align: right;margin-bottom: 5px;">
                                        <input v-model="NewData" type="date" class="form-control"
                                            placeholder="Data Pagamento" />
                                    </v-col>
                                    <v-col cols="12" md="2"
                                        style="text-align: right;padding-right: 15px;padding-top: 20px;">
                                        <button @click="AtualizarPagamentoMassa()" v-show="false" class="btn-sm btn-info">Atualizar
                                            Selecionados</button>
                                    </v-col>

                                </v-row>
                                <v-row style="margin-top: 10px; margin-bottom: 15px;">
                                    <v-col cols="12">
                                        <div style="font-weight: bold; font-size: 16px; text-align: right;">
                                            Total: {{ formatarValor(getTotalParcelas()) }}
                                        </div>
                                    </v-col>
                                </v-row>

                                <adm-data-table :headers="headers" :items="ListCobrancas" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina">
                                    <template #item-garId="item">
                                        <span>{{ListGarantidorasGeral.filter(x => x.garId ==
                                            item.garId)[0].garNomeEmpresa}}</span>
                                    </template>
                                    <template #item-imoId="item">
                                        <span>{{ListImobiliariasGeral.filter(x => x.imoId ==
                                            item.imoId)[0].imoNomeEmpresa}}</span>
                                    </template>
                                    <template #item-pibSumarizacaoValorParcelas="item">
                                        <span>{{ formatarValor(item.pibSumarizacaoValorParcelas) }}</span>
                                    </template>
                                    <template #item-pibValorRetencao="item">
                                        <span>{{ formatarValor(item.pibValorRetencao) }}</span>
                                    </template>
                                    <template #item-pibValorLiquido="item">
                                        <span>{{ formatarValor(item.pibValorLiquido) }}</span>
                                    </template>
                                    <template #item-pibDataVencimento="item">
                                        <span>{{ item.pibDataVencimento != null ? formattedDate(item.pibDataVencimento)
                                            :
                                            null }}</span>
                                    </template>
                                    <template #item-pibDataPagamento="item">
                                        <span>{{ item.pibDataPagamento != null ? formattedDate(item.pibDataPagamento) :
                                            null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <v-btn icon @click="ConfirmaPgto(item)" style="margin-right: 10px;" v-show="false"
                                            variant="text" v-if="item.pibDataPagamento == null">
                                            <v-icon class="editiconcor">mdi-cash</v-icon>
                                            <v-tooltip activator="parent" location="top">Confirmar Pagamento</v-tooltip>
                                        </v-btn>
                                        <v-btn icon @click="EmissaoNF(item)" style="margin-right: 10px;" variant="text"
                                            v-if="item.pibDataPagamento != null">
                                            <v-icon class="editiconcor">mdi-file-code</v-icon>
                                            <v-tooltip activator="parent" location="top">Emissão e-NF</v-tooltip>
                                        </v-btn>
                                    </template>
                                    <template #item-select="item">
                                        <td class="text-center" v-if="item.pibDataPagamento == null">
                                            <v-checkbox v-model="itemsSelected" :value="item" hide-details></v-checkbox>
                                        </td>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <v-row justify="center">
        <v-dialog v-model="dialogPagamento" transition="dialog-bottom-transition" style="width: 320px;">
            <v-card>
                <v-card-text style="padding: 16px 0px 10px" v-if="itemAtual != ''">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="12">
                                    <label>Data Pagamento</label>
                                    <input v-model="pibDataPagamento" type="date" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 13px;color:#ffffff;"
                        @click.prevent="AtualizaPagamento(pibDataPagamento)">Confirmar Pagamento</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'

export default {
    name: 'ControleCobrancasImobiliariasView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0,
        },
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        ListCobrancasGeral: [],
        ListCobrancas: [],
        GarantidoraSelected: null,
        ListGarantidorasGeral: [],
        ImobiliariaSelected: null,
        ListImobiliariasGeral: [],
        ListImobiliarias: [],
        PagamentoSelected: null,
        ListPagamentosGeral: [],
        AnoSelected: null,
        ListAnoGeral: [],
        MesSelected: null,
        ListMesGeral: [
            { Id: 1, Nome: 'Janeiro' },
            { Id: 2, Nome: 'Fevereiro' },
            { Id: 3, Nome: 'Março' },
            { Id: 4, Nome: 'Abril' },
            { Id: 5, Nome: 'Maio' },
            { Id: 6, Nome: 'Junho' },
            { Id: 7, Nome: 'Julho' },
            { Id: 8, Nome: 'Agosto' },
            { Id: 9, Nome: 'Setembro' },
            { Id: 10, Nome: 'Outubro' },
            { Id: 11, Nome: 'Novembro' },
            { Id: 12, Nome: 'Dezembro' }
        ],
        SituacaSelected: null,
        ListSituacaoGeral: [
            { Id: 1, Nome: 'Pago' },
            { Id: 2, Nome: 'Em Aberto' },
        ],
        ListClientes: [],
        ListClientesGeral: [],
        itemAtual: '',
        pibDataPagamento: '',
        dialogPagamento: false,
        itemsSelected: [],
        NewData: '',
        selectedConsumidor: null,
        ListConsumidor: [],
        headers: [],
        statusArray: [],
        dialogStatusNota: false,
        headers2: [
            { text: 'ID', value: 'snfId', align: 'start' },
            { text: 'Status', value: 'snfNome' },
            { text: 'Data de Envio', value: 'dataEnvio' },
            { text: 'Observação', value: 'mensagem' }
        ],
        Nota: [],
        Endereco:[],
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        BuscaImobiliarias() {
            this.ImobiliariaSelected = null;
            this.ListImobiliarias = [];
            this.selectedConsumidor = null;
            this.ListConsumidor = [];

            if (this.GarantidoraSelected === '' || this.GarantidoraSelected === null || this.GarantidoraSelected === undefined) {
                return;
            }
            axios.get(`/Telas/ControleCobrancaImobiliarias/GetByGarIdParIdImobiliarias/` + this.GarantidoraSelected + '/0')
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListImobiliarias = response.data.sort((a, b) =>
                            a.imoNomeEmpresa.localeCompare(
                                b.imoNomeEmpresa,
                                'pt',
                                { sensitivity: 'base' }
                            )
                        );
                    }
                    else {
                        this.ListImobiliarias = [];
                    }
                });
        },
        Cancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        Filtar() {
            let _garId = this.GarantidoraSelected != null ? this.GarantidoraSelected : 0;
            axios.get(`/Telas/ControleCobrancaImobiliarias/GetAllByGarIdPedidoControle/` + _garId)
                .then(response => {
                    this.ListCobrancasGeral = response.data;
                    if (this.ImobiliariaSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.imoId == this.ImobiliariaSelected);
                    }
                    if (this.PagamentoSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pibTipoPgto == this.PagamentoSelected);
                    }
                    if (this.AnoSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => this.$moment(x.pibDataVencimento).format('YYYY') == this.AnoSelected);
                    }
                    if (this.MesSelected != null) {
                        this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => this.$moment(x.pibDataVencimento).format('M') == this.MesSelected);
                    }
                    if (this.SituacaSelected != null) {
                        if (this.SituacaSelected == 1) {
                            this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pibDataPagamento != null);
                        }
                        else if (this.SituacaSelected == 2) {
                            this.ListCobrancasGeral = this.ListCobrancasGeral.filter(x => x.pibDataPagamento == null);
                        }
                    }

                    this.ListCobrancasGeral = this.ListCobrancasGeral.map(item => {
                        const formaPgto = this.ListPagamentosGeral.find(x => x.cfpId == item.pibTipoPgto);
                        return {
                            ...item,
                            pibFormaPgto: formaPgto ? formaPgto.cfpNome : 'Desconhecido'
                        };
                    });

                    this.ListCobrancas = [...this.ListCobrancasGeral].sort((a, b) =>
                        this.$moment(a.pibDataVencimento).diff(this.$moment(b.pibDataVencimento))
                    );

                    //
                    console.log('this.ListCobrancas')
                    console.log(this.ListCobrancas)
                });

        },
        ConfirmaPgto(item) {
            this.itemAtual = item;
            this.dialogPagamento = true;
        },
        async Buscacep(value) {
            if (!value) {
                this.$mensagemAviso('Digite um CEP válido.');
                return null;
            }

            const cep = String(value).replace(/\D/g, '');
            if (cep.length !== 8) {
                this.$mensagemAviso('CEP inválido.');
                return null;
            }

            try {
                const r = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
                const data = r.data;
                if (!data || data.erro) {
                    this.Retornocep = null;
                    this.$mensagemAviso('CEP não encontrado.');
                    return null;
                }

                this.Retornocep = data;
                return data;
            } catch (e) {
                console.error('Erro Buscacep:', e);
                this.Retornocep = null;
                this.$mensagemErro('Erro ao consultar CEP.');
                return null;
            }
        },
        async AtualizaPagamento(pibDataPagamento) {
            if (!pibDataPagamento) {
                return this.$mensagemErro('Selecione uma data de pagamento.');
            }

            const confirm = await this.$mensagemConfirma('Confirma Recebimento da Imobiliaria?');
            if (!confirm.isConfirmed) return;

            const _datapgto = this.$moment(pibDataPagamento).format('YYYY-MM-DD');
            const _dados = {
                PibId: this.itemAtual.pibId,
                GarId: this.itemAtual.garId,
                ImoId: this.itemAtual.imoId,
                PibDataPagamento: _datapgto,
                PibTipoPgto: this.itemAtual.pibTipoPgto,
                PibFormaPgto: this.itemAtual.pibFormaPgto
            };

            try {
                const resp = await axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateSituacaoPgtoImobiliariaControle`, _dados);
                if (!(resp.status == 200 || resp.status == 201)) {
                    return this.$mensagemErro('Erro ao atualizar data de pagamento.');
                }

                const respPmb = await axios.get(`/Telas/ControleCobrancaImobiliarias/GetPmbByPibId/` + this.itemAtual.pibId);
                const ListPmb = respPmb.data || [];

                // Buscar notas por garId uma única vez (por garId único)
                const garIds = [...new Set(ListPmb.map(v => v.garId))];
                const notaByGar = {};
                await Promise.all(garIds.map(async garId => {
                    try {
                        const r = await axios.get(`/Telas/ControleCobrancaImobiliarias/GetByGarIdNota/` + garId);
                        notaByGar[garId] = (r.data && r.data.length > 0) ? r.data[0] : null;
                    } catch (e) {
                        notaByGar[garId] = null;
                    }
                }));

                // Atualiza todos os Pmbs em paralelo
                const updateResults = await Promise.all(ListPmb.map(value => {
                    const _dadospgto = {
                        PmbId: value.pmbId,
                        GarId: value.garId,
                        ImoId: value.imoId,
                        CliId: value.cliId,
                        PedId: value.pedId,
                        PmbDataPagamento: _datapgto,
                        PmbTipoPgto: value.TipoPgto,
                        PmbFormaPgto: value.FormaPgto,
                        PmbEnvioBanco: null,
                        PmbRetornoBanco: null
                    };
                    return axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateSituacaoPgtoPedidoControle`, _dadospgto)
                        .then(r => ({ ok: r.status == 200 || r.status == 201, value }))
                        .catch(() => ({ ok: false, value }));
                }));

                // Coletar pmbIds que precisam emitir nota
                const toEmit = [];
                updateResults.forEach(res => {
                    if (res.ok) {
                        // busca endereço do cliente
                        const response = axios.get(`/Telas/ControleCobrancaImobiliarias/GetEnderecoByCliClienteEndereco/` + res.value.cliId);
                        if (response.data && response.data.length > 0) {
                            this.Endereco = response.data[0];

                            if (!this.Endereco.cleCodigoDistrito || this.Endereco.cleCodigoDistrito === '') {
                                const _dados = this.Buscacep(this.Endereco.cleCep);
                                if (_dados != null) {
                                    this.Endereco.cleCodigoDistrito = String(_dados.ibge);
                                    try {
                                        const upd = axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateClienteEndereco`, this.Endereco);
                                        if (!(upd.status == 200 || upd.status == 201)) {
                                            console.error('Erro ao atualizar endereço');
                                        }
                                    } catch (e) {
                                        console.error('Erro ao atualizar endereço', e);
                                    }
                                }
                            }
                        }               

                        const nota = notaByGar[res.value.garId];
                        if (nota && Number(nota.ggnGeracaoNota) === 1) { // GeracaoNota: 1 = automática, 0 = manual
                            toEmit.push(res.value.pmbId);
                        }
                    }
                });

                // Emitir notas em lote (se necessário)
                let emitSuccess = 0;
                let emitFail = 0;
                if (toEmit.length > 0) {
                    const emitResults = await Promise.all(toEmit.map(pmbId =>
                        axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateEmitirNotaFiscal/` + pmbId)
                            .then(r => r.status == 200)
                            .catch(() => false)
                    ));
                    emitResults.forEach(ok => ok ? emitSuccess++ : emitFail++);
                }

                // Mensagens agregadas e atualização final da grid
                if (toEmit.length > 0) {
                    if (emitFail === 0) {
                        this.$mensagemSucesso(`Nota(s) emitida(s) com sucesso! (${emitSuccess})`);
                    } else {
                        this.$mensagemAviso(`Notas emitidas: ${emitSuccess}. Falha em: ${emitFail}`);
                    }
                } else {
                    this.$mensagemSucesso('Data Recebimento atualizada com sucesso!');
                }

                this.Filtar();
            } catch (e) {
                this.$mensagemErro('Erro ao atualizar data de pagamento.');
            }
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "", value: "select" });
            if (this.User.garid == 0) {
                this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            }
            if (this.User.tpeid != 3) {
                this.headers.push({ text: "Imobiliaria", value: "imoId", sortable: true, });
            }
            this.headers.push({ text: "Vencimento", value: "pibDataVencimento", sortable: true, });
            this.headers.push({ text: "Pagamento", value: "pibDataPagamento", sortable: true, });
            this.headers.push({ text: "Tipo", value: "pibTipoPgto", sortable: true, });
            this.headers.push({ text: "Forma de Pagamento", value: "pibFormaPgto", sortable: true, });
            this.headers.push({ text: "Valor Total", value: "pibSumarizacaoValorParcelas", sortable: true, });
            this.headers.push({ text: "Valor Retenção", value: "pibValorRetencao", sortable: true, });
            this.headers.push({ text: "Valor Liquido", value: "pibValorLiquido", sortable: true, });

            this.headers.push({ text: 'Ações', value: 'actions' });

        },
        exportCSV() {
            if (this.ListCobrancas.length === 0) {
                alert("Não há dados para exportar.");
                return;
            }

            let _Garantidora = "Todas";
            let _Imobliaria = "Todas";
            let _FormaPagamento = "Todas";
            let _Ano = "Todos";
            let _Mes = "Todos";

            if (this.GarantidoraSelected != '' && this.GarantidoraSelected != null) {
                _Garantidora = this.ListGarantidorasGeral.filter(x => x.garId == this.GarantidoraSelected)[0].garNomeEmpresa;
            }

            if (this.ImobiliariaSelected != '' && this.ImobiliariaSelected != null) {
                _Imobliaria = this.ListImobiliariasGeral.filter(x => x.imoId == this.ImobiliariaSelected)[0].imoNomeEmpresa;
            }

            if (this.PagamentoSelected != '' && this.PagamentoSelected != null) {
                _FormaPagamento = this.ListPagamentosGeral.filter(x => x.cfpId == this.PagamentoSelected)[0].cfpNome;
            }

            if (this.AnoSelected != '' && this.AnoSelected != null) {
                _Ano = this.ListAnoGeral.filter(x => x.Id == this.AnoSelected)[0].Nome;
            }

            if (this.MesSelected != '' && this.MesSelected != null) {
                _Mes = this.ListMesGeral.filter(x => x.Id == this.MesSelected)[0].Nome;
            }

            // Cria as linhas de filtros (ajuste os nomes dos filtros conforme necessário)
            const filtroCSV =
                `Garantidora: ${_Garantidora}\n` +
                `Imobiliária: ${_Imobliaria}\n` +
                `Forma Pagamento: ${_FormaPagamento}\n` +
                `Ano: ${_Ano}\n` +
                `Mês: ${_Mes}\n\n`;

            const csvHeader = this.headers
                .slice(2)
                .map(h => h.text)
                .join(";") + "\n";

            // 2) Liste as chaves dinamicamente (aqui já só as que sobraram após slice)
            const keys = this.headers
                .slice(2)
                .map(h => h.value);


            const csvRows = this.ListCobrancas
                .map(item => {
                    return keys
                        .map(key => {
                            if (key === 'pibSumarizacaoValorParcelas') {
                                return this.formatarValor(item.pibSumarizacaoValorParcelas);
                            }
                            if (key === 'pibValorLiquido') {
                                return this.formatarValor(item.pibValorLiquido);
                            }
                            if (key === 'pibValorRetencao') {
                                return this.formatarValor(item.pibValorRetencao);
                            }

                            if (key === ' pibDataVencimento' || key === ' pibDataPagamento') {
                                return item[key]
                                    ? this.formattedDate(item[key])
                                    : '';
                            }

                            // para os demais campos, pega direto do item
                            return item[key] != null ? item[key] : "";
                        })
                        .join(";");
                })
                .join("\n");

            // Concatena os filtros, o cabeçalho e as linhas de dados
            const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + filtroCSV + csvHeader + csvRows;

            // Cria o link de download
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "RelatorioControleCobrancasImobiliarias.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async AtualizarPagamentoMassa() {
            if (!this.NewData) {
                return this.$mensagemErro('Selecione uma data de pagamento.');
            }

            if (!this.itemsSelected || this.itemsSelected.length === 0) {
                return this.$mensagemErro('Selecione um registro para confirmar pagamento.');
            }

            const confirm = await this.$mensagemConfirma('Confirma atualização de todos os itens selecionados?');
            if (!confirm.isConfirmed) return;

            const _datapgto = this.$moment(this.NewData).format('YYYY-MM-DD');

            try {
                // 1) Atualiza todos os PIBs em paralelo
                const pibResults = await Promise.all(this.itemsSelected.map(item => {
                    const payload = {
                        PibId: item.pibId,
                        GarId: item.garId,
                        ImoId: item.imoId,
                        PibDataPagamento: _datapgto,
                        PibTipoPgto: item.pibTipoPgto,
                        PibFormaPgto: item.pibFormaPgto
                    };
                    return axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateSituacaoPgtoImobiliariaControle`, payload)
                        .then(r => ({ ok: r.status == 200 || r.status == 201, item }))
                        .catch(() => ({ ok: false, item }));
                }));

                const successfulPibs = pibResults.filter(p => p.ok).map(p => p.item);
                const failedPibs = pibResults.length - successfulPibs.length;

                // 2) Para os PIBs bem sucedidos, buscar todos os PMBs (em paralelo)
                const pmbResponses = await Promise.all(successfulPibs.map(pib =>
                    axios.get(`/Telas/ControleCobrancaImobiliarias/GetPmbByPibId/` + pib.pibId)
                        .then(r => r.data || [])
                        .catch(() => [])
                ));

                const allPmbs = pmbResponses.flat();

                // 3) Buscar notas por garId uma única vez
                const garIds = [...new Set(allPmbs.map(v => v.garId))];
                const notaByGar = {};
                await Promise.all(garIds.map(async garId => {
                    try {
                        const r = await axios.get(`/Telas/ControleCobrancaImobiliarias/GetByGarIdNota/` + garId);
                        notaByGar[garId] = (r.data && r.data.length > 0) ? r.data[0] : null;
                    } catch (e) {
                        notaByGar[garId] = null;
                    }
                }));

                // 4) Atualizar todos os PMBs em paralelo
                const pmbUpdateResults = await Promise.all(allPmbs.map(value => {
                    const _dadospgto = {
                        PmbId: value.pmbId,
                        GarId: value.garId,
                        ImoId: value.imoId,
                        CliId: value.cliId,
                        PedId: value.pedId,
                        PmbDataPagamento: _datapgto,
                        PmbTipoPgto: value.TipoPgto,
                        PmbFormaPgto: value.FormaPgto,
                        PmbEnvioBanco: null,
                        PmbRetornoBanco: null
                    };
                    return axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateSituacaoPgtoPedidoControle`, _dadospgto)
                        .then(r => ({ ok: r.status == 200 || r.status == 201, value }))
                        .catch(() => ({ ok: false, value }));
                }));

                // 5) Coletar pmbIds que precisam emitir nota
                const toEmit = [];
                let pmbSuccess = 0;
                let pmbFail = 0;
                pmbUpdateResults.forEach(res => {
                    if (res.ok) {
                        // busca endereço do cliente
                        const responsecli = axios.get(`/Telas/ControleCobrancaImobiliarias/GetEnderecoByCliClienteEndereco/` + res.value.cliId);
                        if (responsecli.data && responsecli.data.length > 0) {
                            this.Endereco = responsecli.data[0];

                            if (!this.Endereco.cleCodigoDistrito || this.Endereco.cleCodigoDistrito === '') {
                                const _dadoscli = this.Buscacep(this.Endereco.cleCep);
                                if (_dadoscli != null) {
                                    this.Endereco.cleCodigoDistrito = String(_dadoscli.ibge);
                                    try {
                                        const upd = axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateClienteEndereco`, this.Endereco);
                                        if (!(upd.status == 200 || upd.status == 201)) {
                                            console.error('Erro ao atualizar endereço');
                                        }
                                    } catch (e) {
                                        console.error('Erro ao atualizar endereço', e);
                                    }
                                }
                            }
                        }      


                        pmbSuccess++;
                        const nota = notaByGar[res.value.garId];
                        if (nota && Number(nota.ggnGeracaoNota) === 1) {
                            toEmit.push(res.value.pmbId);
                        }
                    } else {
                        pmbFail++;
                    }
                });

                // 6) Emitir notas em lote (se necessário)
                let emitSuccess = 0;
                let emitFail = 0;
                if (toEmit.length > 0) {
                    const emitResults = await Promise.all(toEmit.map(pmbId =>
                        axios.put(`/Telas/ControleCobrancaImobiliarias/UpdateEmitirNotaFiscal/` + pmbId)
                            .then(r => r.status == 200)
                            .catch(() => false)
                    ));
                    emitResults.forEach(ok => ok ? emitSuccess++ : emitFail++);
                }

                // 7) Agregar mensagens e atualizar grid
                const messages = [];
                if (successfulPibs.length > 0) messages.push(`PIBs atualizados: ${successfulPibs.length}`);
                if (failedPibs > 0) messages.push(`Falha ao atualizar PIBs: ${failedPibs}`);
                if (pmbSuccess > 0) messages.push(`PMBs atualizados: ${pmbSuccess}`);
                if (pmbFail > 0) messages.push(`Falha ao atualizar PMBs: ${pmbFail}`);
                if (toEmit.length > 0) messages.push(`Notas emitidas: ${emitSuccess}. Falhas emissão: ${emitFail}`);

                if (messages.length > 0) {
                    this.$mensagemSucesso(messages.join(' | '));
                } else {
                    this.$mensagemErro('Nenhuma alteração efetuada.');
                }

                this.itemsSelected = [];
                this.Filtar();
            } catch (e) {
                this.$mensagemErro('Erro ao atualizar pagamentos em massa.');
            }
        },
        getTotalParcelas() {
            if (!this.ListCobrancas || this.ListCobrancas.length === 0) {
                return 0;
            }
            return this.ListCobrancas.reduce((total, item) => {
                return total + (item.pibSumarizacaoValorParcelas || 0);
            }, 0);
        },
        async EmissaoNF(value) {
            if (value.pibDataPagamento == null) {
                return this.$mensagemErro('Confirmação de pagamento pendente para esse valor.');
            }

        },
        async Get() {
            await axios.get(`/Telas/ControleCobrancaImobiliarias/GetDados`)
                .then(response => {
                    this.ListGarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                            b.garNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );
                    this.User.tpeid = response.data.tpeId
                    this.User.garid = response.data.garId
                    this.User.pesid = response.data.pesId
                    if (this.User.garid != 0) {
                        this.GarantidoraSelected = this.User.garid;
                        this.BuscaImobiliarias();
                    }
                    if (this.User.tpeid == 3) {
                        this.ImobiliariaSelected = this.User.pesid;
                    }

                    this.ListImobiliariasGeral = response.data.imobiliarias.sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                            b.imoNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );

                    this.ListAnoGeral = [];
                    const anoAtual = new Date().getFullYear();
                    this.ListAnoGeral = Array.from({ length: 7 }, (_, i) => {
                        const ano = anoAtual - 1 + i;
                        return { Id: ano, Nome: String(ano) };
                    });

                    this.ListPagamentosGeral = response.data.cadFormasPagamentos;
                    this.ListClientesGeral = response.data.clientes.filter(x => x.cliAtivo).sort((a, b) =>
                        a.cliNomeEmpresa.localeCompare(
                            b.cliNomeEmpresa,
                            'pt',
                            { sensitivity: 'base' }
                        )
                    );
                    this.montaGrid();
                });

        },
    },
    created() {
        this.Get();

    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
